import {Component, OnInit} from '@angular/core';
import {EvsUserService} from '../../../../common/services/EvsUser.service';
import {EvsErr} from '../evsErr';

declare var jquery: any;
declare var $: any;

@Component({
    selector: 'evs-owner-list',
    templateUrl: 'owner-list.template.html',
    styleUrls: ['style.css'],
    providers: [EvsUserService]
})

export class OwnerListComponent implements OnInit {
    listOwner: any;
    message: any = {content: '', class: ''};
    title: string = 'Danh sách doanh nghiệp';
    login_by_owner_id: any = 0;
    list_role_format: any = {};
    icheck_id_of_user_login: any = 0;

    constructor(private userService: EvsUserService) {
    }

    ngOnInit() {
        let User_data: any = JSON.parse(localStorage.getItem('User'));

        this.icheck_id_of_user_login = User_data.icheck_id ? User_data.icheck_id : 0;
        this.login_by_owner_id = User_data.user_id_evs ? User_data.user_id_evs : 0;
        this.getListOwner();
        this.getListRole();
    }

    getListOwner() {
        this.userService.listOwner().toPromise().then((res: any) => {
            // console.log(res);
            if (res.status == 200) {
                this.listOwner = res.data.length ? res.data : false;
                if (localStorage.getItem('owner_login')) {
                    this.login_by_owner_id = localStorage.getItem('owner_login');
                }
            } else {
                EvsErr.evs_err(res.message, false);
            }
        }).catch((err: any) => {
            EvsErr.evs_err(err);
        });
    }

    getListRole() {
        this.userService.getListRole().toPromise().then((res: any) => {
            if (res.status == 200) {
                // console.log(res.data.roles);
                let roles_format: any = {};
                for (let role of res.data.roles) {
                    roles_format[role.id] = role;
                }
                this.list_role_format = roles_format;
            } else {
                EvsErr.evs_err(res, true);
            }
        }).catch((err: any) => {
            EvsErr.evs_err(err);
        });
    }

    actionAcceptInvitation(id: number) {
        if (id) {
            this.userService.acceptInvitation(id).toPromise().then((res: any) => {
                // console.log(res);
                if (res.status == 200) {
                    let body = $("html, body");
                    body.stop().animate({scrollTop:0}, 500, 'swing', function() {});
                    if (res.data.status == 1) {
                        this.message.content = 'Cập nhật thành công !';
                        this.message.class = 'success';
                        this.getListOwner();
                    } else {
                        this.message.content = 'Cập nhật chưa thành công. Vui lòng thử lại sau';
                        this.message.class = 'warning';
                    }
                } else {
                    this.message = EvsErr.evs_err(res, true);
                }
            }).catch((err: any) => {
                this.message = EvsErr.evs_err(err, true);
            });
        }
    }

    actionLoginByOwner(owner_id: any) {
        if (owner_id && this.login_by_owner_id != owner_id) { // có owner_id va không phải owner_id dang đăng nhập
            this.userService.loginByOwner(owner_id).toPromise().then((res: any) => {
                // console.log('res', res);
                if (res.error == false && res.status == 200) {
                    let tokenEvs = res.data.token;
                    localStorage.setItem('Access-Token', tokenEvs); // save token to local
                    localStorage.setItem('owner_login', owner_id);
                    this.login_by_owner_id = owner_id;
                } else {
                    EvsErr.evs_err(res, false);
                }
            }).catch((err: any) => {
                EvsErr.evs_err(err);
            });
        } else {
            return false;
        }
    }

    actionLeaveOwner(id: any) {
        if (id) {
            if (confirm('Sau khi rời khỏi doanh nghiệp này, bạn sẽ không thể nhìn cũng như thực hiện các chức năng của doanh nghiệp này nữa!')) {
                this.userService.leaveOwner(id).toPromise().then((res: any) => {
                    // console.log(res);
                    if (res.error == false) {
                        $(".owner-id-" + id).fadeOut(500, function () {
                            $(".owner-id-" + id).remove()
                        });
                    } else {
                        this.message = EvsErr.evs_err(res, true);
                    }
                }).catch((err: any) => {
                    this.message = EvsErr.evs_err(err, true);
                });
            }
        } else {
            this.message.content = 'Không xác định được Doanh nghiệp. Vui lòng thử lại';
            this.message.class = "danger"
        }
    }

    removeMessage(){
        this.message.content = '';
    }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/owner-list.component.ts